import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, GiftIcon, DownloadIcon, SmartphoneIcon, LockIcon, ShieldCheckIcon } from 'lucide-react';
const items = [{
  icon: BookOpenIcon,
  text: 'Ebook principal LUMEIA'
}, {
  icon: GiftIcon,
  text: '7 bonus premium incluidos'
}, {
  icon: DownloadIcon,
  text: 'Descarga inmediata'
}, {
  icon: SmartphoneIcon,
  text: 'Compatible con celular'
}, {
  icon: LockIcon,
  text: 'Acceso privado y seguro'
}, {
  icon: ShieldCheckIcon,
  text: 'Garantía de 7 días'
}];
export function WhatsIncluded() {
  return <section className="py-10 md:py-16 px-6" data-id="element-260">
      <div className="max-w-2xl mx-auto" data-id="element-261">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-8" data-id="element-262">
          <p className="text-[11px] md:text-xs tracking-[0.25em] uppercase text-burgundy/60 font-medium mb-3" data-id="element-263">
            El programa completo
          </p>
          <h2 className="font-playfair text-[26px] md:text-4xl text-burgundy leading-tight font-light mb-4" data-id="element-264">
            ¿Qué incluye?
          </h2>
          <div className="w-10 h-px bg-gold/60 mx-auto" data-id="element-265" />
        </motion.div>

        <motion.ul initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="grid grid-cols-1 sm:grid-cols-2 gap-x-6 gap-y-1" data-id="element-266">
          {items.map((item, index) => <motion.li key={index} initial={{
          opacity: 0,
          y: 10
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.05
        }} className="flex items-center gap-3 py-3 border-b border-burgundy/10 last:border-b-0 sm:[&:nth-last-child(2)]:border-b-0" data-id="element-267">
              <item.icon className="w-4 h-4 text-burgundy/70 flex-shrink-0" strokeWidth={1.8} data-id="element-268" />
              <span className="text-charcoal/80 text-[15px] md:text-base" data-id="element-269">
                {item.text}
              </span>
            </motion.li>)}
        </motion.ul>
      </div>
    </section>;
}